export function useQueryParams() {
  function hasParam(key: string) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has(key as string);
  }

  function getParam(key: string, defaultValue?: any) {
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has(key as string)) return defaultValue;

    const value = urlParams.get(key as string);
    if (value === undefined) return defaultValue;

    return value;
  }

  function setParam(key: string, value: any) {
    const urlParams = new URLSearchParams(window.location.search);

    if (value === undefined) {
      urlParams.delete(key as string);
    } else {
      urlParams.set(key as string, value as string);
    }

    window.history.pushState(
      {},
      "",
      `${window.location.pathname}?${urlParams}`
    );
  };

  return { hasParam, getParam, setParam };
}
